export const FETCH_ALL_VEHICLES_SUCCESS = "FETCH_ALL_VEHICLES_SUCCESS";
export const FETCH_ALL_VEHICLES_ERROR = "FETCH_ALL_VEHICLES_ERROR";

